import React, { useEffect, useState } from "react";
import { isMobile } from "../../helperFunc";
import {
  horizontalScrollLeftArrow,
  horizontalScrollRightArrow,
} from "../../icon_assets";
import style from "./style.module.css";
import { scrollLeft, scrollRight } from "../../CommonFunctions/Function";
const ScrollDeskArrow = ({
  scrollRef,
  scrollX,
  setscrollX,
  setscrollEnd,
  scrollEnd,
  leftArrowClassName = `${style["left-arrow-desktop"]}`,
  rightArrowClassName = `${style["right-arrow-desktop"]}`,
  scrollValue = 310,
  ...props
}) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setShow(
        scrollRef?.current?.scrollWidth >= scrollRef?.current?.offsetWidth + 20
      );
    }, 1000);
  }, [scrollRef?.current?.scrollWidth]);

  return (
    <>
      {show ? (
        <>
          {!isMobile && scrollX !== 0 && (
            <img
              src={horizontalScrollLeftArrow}
              alt=""
              className={`positionAbsolute  left-arrow-click cursorPointer ${leftArrowClassName}`}
              onClick={() => {
                scrollLeft(
                  scrollRef,
                  scrollValue,
                  scrollX,
                  setscrollX,
                  setscrollEnd
                );
              }}
            ></img>
          )}
          {!isMobile && !scrollEnd && (
            <img
              src={horizontalScrollRightArrow}
              alt=""
              className={`positionAbsolute  right-arrow-click cursorPointer ${rightArrowClassName}`}
              onClick={() => {
                scrollRight(
                  scrollRef,
                  scrollValue,
                  scrollX,
                  setscrollX,
                  setscrollEnd
                );
              }}
            ></img>
          )}
        </>
      ) : (
        ""
      )}
    </>
  );
};
export default ScrollDeskArrow;
